import FooterOutdoor from "./components/FooterOutdoor";

if (!window.customElements.get("arcteryx-outdoor-footer")) {
  window.customElements.define("arcteryx-outdoor-footer", FooterOutdoor);
}
